export default "__VITE_ASSET__ac87f6ed__"